<template>
	<div>
		<loading :active.sync="isLoading"></loading>
		<div class="row text-left">
			<div class="col-12">
				<div v-html="view" />
			</div>
		</div>
	</div>
</template>

<script>

    export default {
        name: 'transactionDetail',
        props: {
            id: {
                default: 0
            }
        },
        data () {
            return {
                api: window.api,
                t: this.$root.t,
                view: null,
                status: 0,
                isLoading: false,
            }
        },
        mounted () {
            this.fetchTransaction();
        },
        methods: {

            fetchTransaction () {
                this.isLoading = true;
                this.$http.get(api+'api/v1/transaction/view/meta/'+this.id).then(
                    response => {
                    // get body data
                this.view = response.body.result;
                this.isLoading = false;
                this.status = response.status;

            }, response => {
                    this.isLoading = false;
                    this.status = response.status;

                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/transactionMetaView.vue